<template lang="pug">
.col-12
  .carrier.card.shadow.mb-4
    .card-header.py-3
      h3.m-0.font-weight-bold.text-primary() Tracking Status
      i.closeForm.nav-item.fas.fa-fw.fa-times(v-on:click="closeModal()")          
    .card-body
      .col-12(v-if="!loading")
        p Tracking Number: {{trackingData.trackingNumber}}
        p Status: {{trackingData.statusDescription}}
        p(v-if="trackingData.addressCity") City: {{trackingData.addressCity}}
        p(v-else) City: N/A
        p Country: {{trackingData.addressCountry}}    
      .col-12(v-else)
        Spinner
</template>

<script>
import Spinner from 'vue-simple-spinner'
export default {
  name: 'TrackingStatus',
  components:{
    Spinner
  },
  props: {    
    returnLabelInfo:String,
    returnLabelCarrier:String,
  },
  data:function(){
    return{
      trackingData:null,
      loading:true,

    }
  },
  watch:{
      
  },
  computed:{
    
  },
  methods:{
    closeModal(){
      this.$emit('closeModal')
    }
  },
  async mounted(){
    var response = await this.axios.get(`/rp/server/${this.returnLabelCarrier}/track/?returnId=${this.returnLabelInfo}`)
    if(response.data.ups_tracking) this.trackingData = response.data.ups_tracking
    if(response.data.fedex_tracking) this.trackingData = response.data.fedex_tracking
    this.loading = false;
    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
        this.$emit("closeModal");
      }
    };
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
 .closeForm{
    position:absolute;
    right:20px;
    top:20px;
  }
</style>
